export const markupBGB = (text: string) => {
  return text.replace('BGB', '<abbr title="Bürgerliches Gesetzbuch">BGB</abbr>')
}
